export const selectServiceProductOrder = (state) => state.serviceProductOrder;
export const selectServiceProductOrderLoading = (state) => state.serviceProductOrder?.loading;
export const selectServiceProductOrderDone = (state) => state.serviceProductOrder?.done;
export const selectServiceProductOrderError = (state) => state.serviceProductOrder?.error;
export const selectServiceProductOrderInfo = (state) => state.serviceProductOrder?.info;
